/**
 * Created by Gustavo on 31/03/2016.
 */

import {Injectable}                              from '@angular/core';
import {RequestOptions, Headers, Response, Http} from '@angular/http';

import {AppDataService}                          from './app-data.service'

import {Observable}                              from 'rxjs/Observable';

@Injectable()
export class AuthHttpService {
    constructor(private _appData : AppDataService, private _http : Http) {}

    private _prepareRequestOptions(options ?: RequestOptions) : RequestOptions {
        let headers = new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
              });
        options = new RequestOptions({headers : headers});
        
        return options;
    }

    public get(url : string, options?: RequestOptions) : Observable<Response> {
        if (this._appData.token==null){
            return this._http.get(url);
        }
        else {
            return this._http.get(url, this._prepareRequestOptions(options));
        }
    }

    public post(url : string, body : string, options ?: RequestOptions) : Observable<Response>{
        return this._http.post(url,body,this._prepareRequestOptions(options));
    }

    public put(url: string, body: string, options?: RequestOptions) : Observable<Response> {
        return this._http.put(url, body, this._prepareRequestOptions(options));
    }

    public handleError(error : Response) : Observable<any> {
        let status = error.status;
        let errorMessage = `[${status}] : Server Error`;

        switch(status) {
            case 401 : errorMessage = "[401] : Não autorizado para fazer essa ação";
                break;
            case 404 : errorMessage = "[404] : Rota não encontrada. Por favor, entre em contado com o webmaster";
                break;
        }
        console.error(errorMessage);
        return Observable.throw(errorMessage);
    }
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/services/auth-http.service.ts